import React from 'react';
import ReactDOM from 'react-dom';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
//import "./Assets/scss/mdb.scss";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//import { history, connect, express} from 'connect-history-api-fallback';

ReactDOM.render(
    
        <App />,

        document.getElementById('root')
    );
    
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
